import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-widget-top-bar',
    templateUrl: './widget-top-bar.component.html',
    styleUrls: ['./widget-top-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetTopBarComponent implements OnInit {
  static readonly componentName = 'WidgetTopBarComponent';
  
  constructor() { }

  ngOnInit() {
  }

}
